import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../config.js';

export default function SEO({
  title,
  description,
  path = '',
  image = '/og/default.png',
  type = 'website',
  schema = [],
}) {
  const fullTitle = title
    ? `${title} · FocusMode`
    : 'FocusMode · סדר בפרויקטים, מערכות ותהליכים';
  const desc = description
    || 'FocusMode עוזרת לעסקים בצמיחה לעשות סדר בפרויקטים, אתרים, מערכות, אוטומציות ותהליכים שהפכו כבדים מדי לניהול ידני.';
  const url = `${SITE_URL}${path}`;
  const fullImage = image.startsWith('http') ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:locale" content="he_IL" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={fullImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={fullImage} />
      {schema.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
